import { render, staticRenderFns } from "./EntityGroups.vue?vue&type=template&id=224fccb8&scoped=true&"
import script from "./EntityGroups.vue?vue&type=script&lang=js&"
export * from "./EntityGroups.vue?vue&type=script&lang=js&"
import style0 from "./EntityGroups.vue?vue&type=style&index=0&id=224fccb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224fccb8",
  null
  
)

export default component.exports